<template>
  <section id="remote">
      <a class="close" href="#" @click="closeRemoteForm">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="32" height="32" rx="4" />
            <path d="M25 7L7 25M25 25L7 7L25 25Z" stroke="black" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </a>
      <h2 class="instructions">Gå in på <em>{{url}}</em> och ange den 4-siffriga koden nedan.</h2>
      <input type="password" :value="code.toUpperCase()" @input="code = $event.target.value.toUpperCase()" @keyup.enter="submitCode" maxlength="4" placeholder="xxxx" />
  </section>
</template>

<script>
export default {
    name: 'RemoteCodeForm',
    data(){
        return {
            code: '',
            url: 'https://toolie.se/selfie/remote'
        }
    },
    methods: {
        submitCode(){
            
            if(this.code.length === 4){
                this.$store.commit('toggleRemoteForm');
                this.$emit('connectWS', this.code)
            } else {
                alert('Remote code must be 4 chars long.');
            }
        },
        closeRemoteForm(){
            this.$store.commit('toggleRemoteForm');
        }
    }
}
</script>

<style lang="scss">
@import '../scss/variables';

$base: 2.4rem;

#remote {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,.9);
    z-index: 99999;
    display: flex;
    @include center;
    flex-direction: column;

    .instructions {
        max-width: 30rem;
        width: 100%;
        font-size: 1.4rem;
        font-weight: 300;
        text-align: center;
        margin: 2rem;
        color: rgba($color: #fff, $alpha: .6);

        em {
            font-weight: 500;
        }
    }

    a {
        position: absolute;
        top: 1.5rem;
        left: 1.5rem;
        padding: 0;
        @include center;
        height: $base;
        width: $base;
        border-radius: .25rem;
        background: #EEE;
        border: .5rem solid white;
        transition: all .2s ease;
        box-sizing: content-box;
    }

    > input {
        font-size: $font-big;
        border: none;
        border-radius: $radius;
        max-width: 10rem;
        text-align: center;
        padding: .25rem .75rem;
        letter-spacing: .25rem;
        width: 100%;
        background: #eee;
    }
}
</style>